import { NavLink } from "react-router-dom";
import { LayoutDashboard, Package, FileText, Settings, Plus, Users, ScanLine, FileSpreadsheet, LogOut, UserCog, BarChart3, Building2, Receipt, Inbox, Landmark, QrCode, UserPlus, Wallet, ListChecks, ClipboardList } from "lucide-react";
import { useAuth, canDo } from "@/context/AuthContext";

const LOGO_URL =
    "https://customer-assets-jai6qajn.emergentagent.net/job_pdf-guide-dev/artifacts/7s3f15d0_HDB%20LOGO.webp";

export default function Sidebar() {
    const { user, logout } = useAuth();
    if (!user) return null;

    const link = ({ isActive }) =>
        `flex items-center gap-3 px-5 py-2.5 text-sm font-medium border-l-[3px] ${
            isActive ? "active" : "border-transparent text-slate-300 hover:text-white hover:bg-white/5"
        }`;

    return (
        <aside className="hdb-sidebar app-sidebar flex flex-col" data-testid="app-sidebar">
            <div className="px-5 py-5 border-b border-white/10">
                <div className="flex items-center gap-3">
                    <div className="bg-white rounded-md p-1.5">
                        <img src={LOGO_URL} alt="HDB" className="h-8 w-auto" />
                    </div>
                    <div>
                        <div className="hdb-heading font-black text-white leading-tight">HDB Billin App</div>
                        <div className="text-[10px] uppercase tracking-widest text-emerald-300">Har Din Bachat</div>
                    </div>
                </div>
            </div>

            <NavLink to="/dashboard" className={link} data-testid="nav-dashboard">
                <LayoutDashboard size={16} /> Dashboard
            </NavLink>
            {canDo(user, "admin") && (
                <NavLink to="/items" className={link} data-testid="nav-items">
                    <Package size={16} /> Item Master
                </NavLink>
            )}
            <NavLink to="/invoices" className={link} data-testid="nav-invoices">
                <FileText size={16} /> Invoices
            </NavLink>
            <NavLink to="/clients" className={link} data-testid="nav-clients">
                <Users size={16} /> Clients
            </NavLink>
            <NavLink to="/leads" className={link} data-testid="nav-leads">
                <UserPlus size={16} /> Leads
            </NavLink>
            <NavLink to="/vendors" className={link} data-testid="nav-vendors">
                <Building2 size={16} /> Vendors
            </NavLink>
            <NavLink to="/purchase-orders" className={link} data-testid="nav-purchase-orders">
                <ClipboardList size={16} /> Purchase Orders
            </NavLink>
            <NavLink to="/purchases" className={link} data-testid="nav-purchases">
                <Receipt size={16} /> Purchases
            </NavLink>
            <NavLink to="/purchase-reports" className={link} data-testid="nav-purchase-reports">
                <BarChart3 size={16} /> Purchase Reports
            </NavLink>
            <NavLink to="/bank-recon" className={link} data-testid="nav-bank-recon">
                <Landmark size={16} /> Bank Recon
            </NavLink>
            <NavLink to="/expenses" className={link} data-testid="nav-expenses">
                <Wallet size={16} /> Expenses
            </NavLink>
            {canDo(user, "invoicing_staff") && (
                <NavLink to="/planner-admin" className={link} data-testid="nav-planner-admin">
                    <ListChecks size={16} /> Essentials Planner
                </NavLink>
            )}
            <NavLink to="/client-orders" className={link} data-testid="nav-client-orders">
                <Inbox size={16} /> Client Orders
            </NavLink>
            {canDo(user, "invoicing_staff") && (
                <>
                    <NavLink to="/invoices/new" className={link} data-testid="nav-new-invoice">
                        <Plus size={16} /> New Invoice
                    </NavLink>
                    <NavLink to="/invoices/from-po" className={link} data-testid="nav-import-po">
                        <ScanLine size={16} /> Import from PO
                    </NavLink>
                </>
            )}
            <NavLink to="/reports" className={link} data-testid="nav-reports">
                <BarChart3 size={16} /> Reports
            </NavLink>
            <NavLink to="/reports/gstr1" className={link} data-testid="nav-gstr1">
                <FileSpreadsheet size={16} /> GSTR-1 Report
            </NavLink>
            {canDo(user, "admin") && (
                <>
                    <NavLink to="/qr-poster" className={link} data-testid="nav-qr-poster">
                        <QrCode size={16} /> QR Poster
                    </NavLink>
                    <NavLink to="/users" className={link} data-testid="nav-users">
                        <UserCog size={16} /> Users & Roles
                    </NavLink>
                    <NavLink to="/settings" className={link} data-testid="nav-settings">
                        <Settings size={16} /> Settings
                    </NavLink>
                </>
            )}

            <div className="mt-auto px-5 py-4 border-t border-white/10">
                <div className="text-[11px] text-slate-400 mb-1">Signed in as</div>
                <div className="text-xs text-white font-semibold truncate" data-testid="me-name">{user.name || user.email}</div>
                <div className="text-[10px] text-emerald-300 uppercase tracking-widest mt-0.5" data-testid="me-role">
                    {user.role.replace("_", " ")}
                </div>
                <button onClick={logout} className="mt-3 flex items-center gap-1.5 text-[11px] text-slate-300 hover:text-white"
                        data-testid="logout-btn">
                    <LogOut size={11} /> Sign out
                </button>
            </div>
        </aside>
    );
}
